<template>
  <b-modal
    id="PTVChangePasswordModal"
    size="md"
    hide-header-close
    @show="initChangePassword"
  >
    <b-container class="px-2">
      <b-row class="pt-1 pb-3 w-100" no-gutters>
        <b-col class="w-75 anchor-left">
          <label class="blue-text pl-2">Old Password</label>
          <div class="password-wrapper position-relative w-100">
            <b-form-input
              :type="passwordVisible ? 'text' : 'password'"
              name="oldPassword"
              v-model="form.oldPassword"
              autocomplete="off"
              class="input-field pl-3"
              :class="missingFields.oldPassword ? 'red' : ''"
              @focus="focused.old = true; focused.new = false; focused.confirm = false;"
            />
            <fa v-if="focused.old" :icon="['fas', passwordVisible ? 'eye-slash' : 'eye']" class="password-toggle" @click="passwordVisible = !passwordVisible"/>
          </div>
        </b-col>
      </b-row>

      <b-row class="py-3 w-100" no-gutters>
        <b-col class="w-75 anchor-left">
          <label class="blue-text pl-2">New Password</label>
          <div class="password-wrapper position-relative w-100">
            <b-form-input
              :type="passwordVisible ? 'text' : 'password'"
              name="newPassword"
              v-model="form.newPassword"
              autocomplete="off"
              class="input-field pl-3"
              :class="missingFields.newPassword ? 'red' : ''"
              @focus="focused.new = true; ; focused.old = false; focused.confirm = false;"
            />
            <fa v-if="focused.new" :icon="['fas', passwordVisible ? 'eye-slash' : 'eye']" class="password-toggle" @click="passwordVisible = !passwordVisible"/>
          </div>
        </b-col>
      </b-row>

      <b-row class="py-3 w-100" no-gutters>
        <b-col class="w-75 anchor-left">
          <label class="blue-text pl-2">Confirm New Password</label>
          <div class="password-wrapper position-relative w-100">
            <b-form-input
              :type="passwordVisible ? 'text' : 'password'"
              name="confirmPassword"
              v-model="form.confirmPassword"
              autocomplete="off"
              class="input-field pl-3"
              :class="missingFields.confirmPassword ? 'red' : ''"
              @focus="focused.confirm = true; focused.old = false; focused.new = false;"
            />
            <fa v-if="focused.confirm" :icon="['fas', passwordVisible ? 'eye-slash' : 'eye']" class="password-toggle" @click="passwordVisible = !passwordVisible"/>
          </div>
        </b-col>
      </b-row>

      <b-row class="py-2 w-100 justify-content-center" no-gutters>
        <b-button class="save-btn px-4 py-2" @click="checkForm()">Save new password</b-button>
      </b-row>
    </b-container>
    <template #modal-header>
      <div class="d-flex align-items-center justify-content-between w-100">
        <h5 class="mb-0 font-weight-semibold text-white">Change Password</h5>
      </div>
    </template>
    <template #modal-footer>
      <b-row class="w-100 justify-content-end">
        <b-button class="close-btn px-4 py-2" @click="closeModal()">Close</b-button>
      </b-row>
    </template>
  </b-modal>
</template>

<style src="./Data_Tools.css" scoped></style>

<style>
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 0.625rem;   /* distance from right edge */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #555;
}
.toast-multiline {
  white-space: pre-line;
}
.blue-text {
  font-size: 0.9rem;
  color: #063c6d; 
  /* opacity: 0.8; */
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.anchor-left {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}
.input-field {
  height: calc(1.5em + 0.9rem + 2px);
  width: 100%;
  /* border-radius: calc((1.5em + 0.9rem + 2px) / 2) !important; */
  font-size: 0.9rem !important;
  color: #063c6d !important;
}
.close-btn {
  font-size: 0.75rem !important;
  /* background-color: navy !important; */
  background-color: #063c6d !important;
  border: none !important; 
  border-radius: 20px !important;
  min-height: 2.5rem;
  min-width: 5rem;
}

.save-btn {
  font-size: 0.75rem !important;
  border: none !important; 
  min-height: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #063C6D;
}

.close-btn:hover {
  background-color: rgb(6, 60, 109, 0.8) !important;
}

.save-btn:hover {
  background-color: rgb(6, 60, 109, 0.8) !important;
}

@media (max-width: 470px) {
  .xs-spacing {
    padding-top: 2rem;
  }
}
@media (min-width: 768px) {
  .modal-width {
    width: 65%;
    max-width: 43.75rem;
  }
}
.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 6.25rem;
  font-size: 0.9375rem !important;
  top: 18%;
  margin-left: 1.875rem;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 0.3125rem 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000 !important;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.pass-btn-spacing {
  margin: 0px 1.25rem 0px 1.25rem;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'DT_ChangePassword',
  components: {},
  data() {
    return {
      form: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      },
      userId: null,
      content: null,
      passwordVisible: false,
      missingFields: {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
      },
      passwordVisible: false,
      focused: {
        old: false,
        new: false,
        confirm: false
      }
    }
  },
  methods: {
    closeModal() {
      this.clear()
      this.$bvModal.hide('PTVChangePasswordModal')
    },
    initChangePassword() {
      this.clear()
      this.getUser()
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },
    clear() {
      this.form.oldPassword = null
      this.form.newPassword = null
      this.form.confirmPassword = null
      this.missingFields = {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
      }
    },
    submit() {
      if (sessionStorage.token && typeof sessionStorage.token == "string") {
        axios
          .get(process.env.API_LOCATION + '/api/users/changePassword', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.userId,
              newPassword: this.form.newPassword
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              //this.submitSuccess = 'Password changed successfully.'
              this.$bvToast.toast('Password changed successfully.', {
                title: 'Change Password Status',
                variant: 'success',
                solid: true,
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 7000
              })
            }
            this.clear()
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    checkForm: function (e) {
      let errors = []
      if (!this.form.oldPassword) {
        this.$bvToast.toast('Current Password required.', {
          title: 'Form Errors',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 7000
        })
        this.missingFields.oldPassword = true;
        setTimeout(() => {
          this.missingFields = {
            oldPassword: false,
            newPassword: false,
            confirmPassword: false
          }
        }, 7000)
      } else {
        axios
          .get(process.env.API_LOCATION + '/api/users/verifyOldPassword', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.userId,
              oldPassword: this.form.oldPassword
            }
          })
          .then(response => {
            this.content = response.data.msg

            if (this.content == 'testaccount') {
              errors.push(
                'Test accounts cannot change their password.'
              )
            } else {
              if (!this.content) {
                errors.push('Current password does not match.')
              }
              if (!this.form.newPassword) {
                errors.push('New Password required.')
                this.missingFields.newPassword = true;
              }
              if (this.form.newPassword && this.form.newPassword.length < 6) {
                errors.push(
                  'Please enter a password with 6 or more characters.'
                )
              }
              if (!this.form.confirmPassword) {
                errors.push('Confirm Password required.')
                this.missingFields.confirmPassword = true;
              }
              if (this.form.newPassword && this.form.confirmPassword) {
                if (this.form.newPassword != this.form.confirmPassword) {
                  errors.push(
                    'New password and confirm password do not match.'
                  )
                }
              }
              if (errors.length) {
                this.$bvToast.toast(errors.join('\n'), {
                  title: 'Form Errors',
                  variant: 'danger',
                  solid: true,
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 7000,
                  noCloseButton: false,
                  appendToast: false,
                  toastClass: 'toast-multiline'
                })
                setTimeout(() => {
                  this.missingFields = {
                    oldPassword: false,
                    newPassword: false,
                    confirmPassword: false
                  }
                }, 7000)
              } else if (this.content) {
                this.submit()
              }
            }
            this.content = null
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getUser() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            this.userId = response.data ? response.data.id ? response.data.id : null : null
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
    }
  }
}
</script>
